import { Navigate, Outlet } from "react-router-dom";
// import { useAuth } from "./contexts/AuthContext";
import useAuthStore from "./zustand-stores/AuthStore";
import { useEffect } from "react";

const ProtectedRoute = () => {
  // const { isAuthenticated, loading } = useAuth();
  const { authStateLoading, authSessionExists } = useAuthStore();

  useEffect(() => {

  }, [authSessionExists]);

  if (authStateLoading) {
    return <div>Loading...</div>;
  }

  return authSessionExists ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
